
if (typeof define === 'function') {
  define('jquery-private',['require'],function ($) {
    return $.noConflict( true );
  });
}
;